










/* General */
import Vue from 'vue'
import { EEntities } from '@/types'
import TextAssistant from '@/helpers/text-assistant'

export default Vue.extend({
  name: 'StaleItemAlert',

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
  },

  data() {
    return {
      TextAssistant,
    }
  },
})
